export default __webpack_public_path__ + "static/media/PM.838a4f91.svg";